import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  popoverSection: {
    padding: theme.spacing(4),
    maxWidth: 300,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
  dependsOnText: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
  dependsOnCheckbox: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
});

function MyPopOver(props) {
  const {
    popupOpen,
    handlePopupClose,
    classes,
    dependsOnText,
    dependsChecked,
    handleDependsCheckboxChange,
    dependsOnCheckbox,
    dependsLink,
    popupAnchor,
  } = props;

  return (
    <Popover
      open={popupOpen}
      onClose={handlePopupClose}
      anchorEl={popupAnchor}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
    >
      <div className={classes.popoverSection}>
        <Typography variant="body1" className={classes.dependsOnText}>{dependsOnText}</Typography>
        <FormControlLabel
          control={(
            <Checkbox
              checked={dependsChecked}
              onChange={e => handleDependsCheckboxChange(e)}
            />
          )}
          label={dependsOnCheckbox}
          className={classes.dependsOnCheckbox}
        />
        <div className={classes.buttonContainer}>
          <Button onClick={handlePopupClose} variant="contained" color="secondary" disabled={!dependsChecked} target="_blank" rel="noopener noreferrer" href={dependsLink}>Continue</Button>
        </div>
      </div>
    </Popover>
  );
}

MyPopOver.propTypes = {
  classes: PropTypes.object.isRequired,
  dependsOnText: PropTypes.string.isRequired,
  dependsOnCheckbox: PropTypes.string.isRequired,
  dependsChecked: PropTypes.bool.isRequired,
  popupOpen: PropTypes.bool.isRequired,
  handlePopupClose: PropTypes.func.isRequired,
  handleDependsCheckboxChange: PropTypes.func.isRequired,
  dependsLink: PropTypes.string.isRequired,
  popupAnchor: PropTypes.object,
};

export default withStyles(styles)(MyPopOver);
